import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { HashRouter as Router } from 'react-router-dom';
import { store } from './reducers';

import SplashScreen from './screens/Splash/SplashScreen';

import './less/index.less';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <SplashScreen />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
